import { createContext, useEffect, useState } from "react";
import clienteAxios from "../config/clienteAxios";

const ArticleSliderContext = createContext();

const ArticleSliderProvider = ({ children }) => {
  const [articlesSlider, setArticlesSlider] = useState([]);

  useEffect(() => {
    const obtenerArticulos = async () => {
      try {
        const { data } = await clienteAxios.get("/article/getAll");

        setArticlesSlider(data.allArticles);
      } catch (error) {
        console.log(error);
      }
    };
    obtenerArticulos();
  }, []);

  return (
    <ArticleSliderContext.Provider
      value={{
        articlesSlider,
      }}
    >
      {children}
    </ArticleSliderContext.Provider>
  );
};

export { ArticleSliderProvider };

export default ArticleSliderContext;